module.exports = __webpack_public_path__ + "img/4.8f03f7e7.png";